export interface CrediflowPartyService {
  serviceTypeID: string;
  instructions: string;
  compliance: string;
}

export interface CrediflowParty {
  id: number;
  name: string;
  address1: string;
  address2: string;
  zipCode: string;
  city: string;
  countryCode: string;
  contactName: string;
  phone: string;
  fax: string;
  email: string;
  cin: string;
  gln: string;
  vat: string;
  bankgiro: string;
  plusGiro: string;
  iban: string;
  bic: string;
  services: CrediflowPartyService[];
}

export const getPartyCompliance = (party: CrediflowParty): string => {
  const svc = party.services?.find((x) => x.serviceTypeID === 'ReceiveElectronicInvoices');
  return svc?.compliance ?? '';
};
